import deepmerge from "deepmerge";
import Storage from "./Storage";
import { Session, SessionData } from "../model/Session";

export default class ViewStore {
    private storage: Storage<{ session?: SessionData }>;
    private state: ViewState = {};
    private updateStateCallback?: (state: ViewState) => void;

    constructor(storage: Storage<{ session?: SessionData }>) {
        this.storage = storage;
        const storageState = this.storage.getState();
        this.state = {
            session: storageState.session,
        };
    }

    readonly updateState = (state: Partial<ViewState>): void => {
        const overwriteMerge = (destinationArray: Array<any>, sourceArray: Array<any>) => sourceArray;
        this.state = deepmerge(this.state, state, { arrayMerge: overwriteMerge });

        this.updateStateCallback && this.updateStateCallback(this.state);

        if (!this.updateStateCallback) {
            console.warn('store: no callback for updateState');
        }
    }

    readonly setUpdateStateCallback = (callback: (state: ViewState) => void): boolean => {
        if (!this.updateStateCallback) {
            this.updateStateCallback = callback;
            return true;
        }

        console.warn('store: callback for updateState already set')
        return false;
    }

    readonly getState = (): ViewStateReader => {
        return new ViewStateReader(this.state);
    }
}

class ViewStateReader implements ViewState {
    private viewState: ViewState;

    constructor(viewState: ViewState) {
        this.viewState = viewState;
    }

    get session() {
        const data = this.viewState.session;
        return data ? new Session(data) : undefined;
    }
}

export interface ViewState {
    readonly session?: SessionData,
    readonly requestedRoute?: string
}